import {
  REQUEST_EMPLOYER_BENEFIT_BY_DUNS,
  RECEIVE_EMPLOYER_BENEFIT_BY_DUNS,
  REQUEST_EMPLOYER_BENEFIT_BY_DUNS_ERROR,
  CLEAR_EMPLOYER_BENEFIT_BY_DUNS,
  CLEAR_EMPLOYER_PRICING_BENEFITS,
  REQUEST_EMPLOYER_BENEFITS_BY_NAME,
  RECEIVE_EMPLOYER_BENEFITS_BY_NAME,
  REQUEST_EMPLOYER_BENEFITS_BY_NAME_ERROR,
} from './types';
import STATUS from '../../globalStatuses';
import { errorToMessage } from '../../../errorMessaging';

const initialState = {
  employerBenefitsGeneration: 0,
  pendingDuns: null,
  lastFetchedDuns: null,
  employerBenefitByDuns: null,
  employerBenefitByDunsStatus: {
    getStatus: STATUS.UNFETCHED,
    errorData: null,
  },
  employerBenefitsByDuns: {},
  employerBenefitStatusesByDuns: {},
  employerBenefitsByName: null,
  employerBenefitsByNameStatus: {
    getStatus: STATUS.UNFETCHED,
    errorData: null,
  },
};

function pricing(state = initialState, action) {
  const isCurrentEmployerBenefitsGeneration = action.generation === undefined
    || action.generation === state.employerBenefitsGeneration;
  switch (action.type) {
    case REQUEST_EMPLOYER_BENEFIT_BY_DUNS:
      return {
        ...state,
        pendingDuns: action.dunsNumber,
        employerBenefitStatusesByDuns: {
          ...state.employerBenefitStatusesByDuns,
          [action.dunsNumber]: {
            getStatus: STATUS.FETCHING,
            errorData: null,
          },
        },
        employerBenefitByDunsStatus: {
          ...state.employerBenefitByDunsStatus,
          getStatus: STATUS.FETCHING,
          errorData: null,
        },
      };
    case RECEIVE_EMPLOYER_BENEFIT_BY_DUNS:
      if (!isCurrentEmployerBenefitsGeneration) return state;
      return {
        ...state,
        employerBenefitsByDuns: {
          ...state.employerBenefitsByDuns,
          [action.dunsNumber]: action.benefit,
        },
        employerBenefitStatusesByDuns: {
          ...state.employerBenefitStatusesByDuns,
          [action.dunsNumber]: {
            getStatus: STATUS.FETCHED,
            errorData: null,
          },
        },
        // Retain the legacy latest-response fields for existing non-Work consumers.
        ...(state.pendingDuns === action.dunsNumber ? {
          pendingDuns: null,
          lastFetchedDuns: action.dunsNumber,
          employerBenefitByDuns: action.benefit,
          employerBenefitByDunsStatus: {
            ...state.employerBenefitByDunsStatus,
            getStatus: STATUS.FETCHED,
            errorData: null,
          },
        } : {}),
      };
    case REQUEST_EMPLOYER_BENEFIT_BY_DUNS_ERROR:
      if (!isCurrentEmployerBenefitsGeneration) return state;
      return {
        ...state,
        employerBenefitStatusesByDuns: {
          ...state.employerBenefitStatusesByDuns,
          [action.dunsNumber]: {
            getStatus: action.error?.response?.status === 404 ? STATUS.FETCHED : STATUS.ERROR,
            errorData: errorToMessage(action.error),
          },
        },
        ...(state.pendingDuns === action.dunsNumber ? {
          pendingDuns: null,
          employerBenefitByDunsStatus: {
            ...state.employerBenefitByDunsStatus,
            getStatus: action.error?.response?.status === 404 ? STATUS.FETCHED : STATUS.ERROR,
            errorData: errorToMessage(action.error),
          },
        } : {}),
      };

    case CLEAR_EMPLOYER_BENEFIT_BY_DUNS:
      return {
        ...state,
        pendingDuns: null,
        lastFetchedDuns: null,
        employerBenefitByDuns: null,
        employerBenefitByDunsStatus: {
          getStatus: STATUS.UNFETCHED,
          errorData: null,
        },
      };
    case CLEAR_EMPLOYER_PRICING_BENEFITS:
      return {
        ...state,
        employerBenefitsGeneration: state.employerBenefitsGeneration + 1,
        pendingDuns: null,
        lastFetchedDuns: null,
        employerBenefitByDuns: null,
        employerBenefitByDunsStatus: {
          getStatus: STATUS.UNFETCHED,
          errorData: null,
        },
        employerBenefitsByDuns: {},
        employerBenefitStatusesByDuns: {},
      };

    case REQUEST_EMPLOYER_BENEFITS_BY_NAME:
      return {
        ...state,
        employerBenefitsByNameStatus: {
          ...state.employerBenefitsByNameStatus,
          getStatus: STATUS.FETCHING,
          errorData: null,
        },
      };
    case RECEIVE_EMPLOYER_BENEFITS_BY_NAME:
      return {
        ...state,
        employerBenefitsByName: action.benefits,
        employerBenefitsByNameStatus: {
          ...state.employerBenefitsByNameStatus,
          getStatus: STATUS.FETCHED,
          errorData: null,
        },
      };
    case REQUEST_EMPLOYER_BENEFITS_BY_NAME_ERROR:
      return {
        ...state,
        employerBenefitsByNameStatus: {
          ...state.employerBenefitsByNameStatus,
          getStatus: action.error?.response?.status === 404 ? STATUS.FETCHED : STATUS.ERROR,
          errorData: errorToMessage(action.error),
        },
      };

    default:
      return state;
  }
}

// ─── Selectors ───────────────────────────────────────────────────────────────

export const selectEmployerBenefitByDuns = state => state.pricing.employerBenefitByDuns;
export const selectEmployerBenefitByDunsStatus = state => state.pricing.employerBenefitByDunsStatus;
export const selectEmployerBenefitsByDuns = state => state.pricing.employerBenefitsByDuns;

export const selectEmployerBenefitsByName = state => state.pricing.employerBenefitsByName;
export const selectEmployerBenefitsByNameStatus = state => (
  state.pricing.employerBenefitsByNameStatus
);

export default pricing;
